import { Component } from '@verndale/core';
import { searchAirports, highlightAirports } from '../helpers/search';
import Autocomplete from '../components/Autocomplete';
import { getAirports } from '../service/oneworld';

class FindLounges extends Component {
  setupDefaults() {
    this.dom = {
      $form: this.$el.find('.js-find-lounges__form'),
      $location: this.$el.find('.autocomplete')
    };

    this.airportsUrl = this.dom.$form.data('airportsUrl');
    this.redirectUrl = this.dom.$form.data('redirect-url');
    this.loungeListId = this.dom.$form.data('lounge-list-id');
    this.redirectWhenLocationParams = this.dom.$form.data('redirect-when-location-params');

    this.location = new Autocomplete(this.dom.$location, {
      filter: ::this.filterAirports,
      render: highlightAirports,
      value: ::this.getAirportValue
    });

    this.handleRedirect();
  }

  addListeners() {
    this.dom.$form.on('submit', ::this.handleSubmit);
  }

  handleRedirect() {
    if (this.redirectWhenLocationParams) {
      // eslint-disable-next-line no-undef
      const urlParams = new URLSearchParams(window.location.search);
      const location = urlParams.get('location');

      if (location && this.redirectUrl) {
        const listId = this.loungeListId ? `#${this.loungeListId}` : '';
        window.location.href = `${this
          .redirectUrl}?location=${location}${listId}`;
      }
    }
  }

  async filterAirports(value) {
    if (!value || value.length < 2) {
      return [];
    }
    const airports = await getAirports({
      url: this.airportsUrl
    });
    return searchAirports(airports, value);
  }

  getAirportValue(item) {
    return `${item.item.Name}`;
  }

  handleSubmit(e) {
    e.preventDefault();
    const data = {};
    const locationItem = this.location.getSelectedItem();

    if (locationItem) {
      data.location = locationItem.Code;
    }

    if (this.props.onFind && !this.redirectUrl) {
      this.props.onFind(data);
    } else {
      const listId = this.loungeListId ? `#${this.loungeListId}` : '';
      window.location.href = `${this
        .redirectUrl}?location=${data.location}${listId}`;
    }
  }

  async findItemByCode(code) {
    const airports = await getAirports({ url: this.airportsUrl });
    return airports.find(item => item.Code === code);
  }

  async setLocation(code) {
    const item = await this.findItemByCode(code.toUpperCase());
    this.location.setSelectedItem({ item });
  }
}

export default FindLounges;
